import React from 'react';
import PropTypes from 'prop-types';

const LinkWrap = ({ children, listingURL, openInSameTab, onClick }) => {
  const target = openInSameTab ? '' : '_blank';

  return (
    <a target={ target } rel={!openInSameTab ? 'noopener' : ''} href={ listingURL || '#' } onClick={ onClick } >
      { children }
    </a>
  );
};

export default LinkWrap;
